import React, {Component} from 'react';
import {
  Row,
  Col,
  Form,
  FormGroup,
  Label,
  Input,
  Card,
  CardHeader,
  CardBody,
  Button
} from 'reactstrap'
import StudentHeader from './StudentHeader';
import ShowRecords from './ShowRecords';

const isOnLOP = require('../utilities/isOnLOP');
const R = require('ramda')

class Check extends Component {

  constructor(props) {
    super(props);
    this.state = {
      stuID: '',
      student: null,
      records: null,
      schedule: null
    }
    this.stuID = null;
    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  componentWillUnmount() {
    if (this.stuID) {
      this.props.db.ref('students/' + this.stuID).off();
      this.props.db.ref('records/' + this.stuID).off();
      this.props.db.ref('schedules/' + this.stuID).off();
    }
  }

  onSubmit(evt) {
    evt.preventDefault();
    this.stuID = this.state.stuID;
    if (this.stuID) {
      this.props.db.ref('students/' + this.stuID).off();
      this.props.db.ref('records/' + this.stuID).off();
      this.props.db.ref('schedules/' + this.stuID).off();
    }
    let _this = this;
    this.props.db.ref('students/'+this.state.stuID).on('value', snap => {
      _this.setState({student: snap.val()});
    });
    this.props.db.ref('records/'+this.state.stuID).on('value', snap => {
      let recordObjs = R.mapObjIndexed((val, key) => {
        val.key = key;
        return val
      }, snap.val())
      _this.setState({records: R.values(recordObjs)});
    });
    this.props.db.ref('schedules/'+this.state.stuID).on('value', snap => {
      _this.setState({schedule: snap.val()});
    });
  }

  onChange(evt) {
    let field = evt.currentTarget.getAttribute('name');
    this.setState(R.assoc(field, evt.currentTarget.value, {}))
  }

  render() {
    let s = this.state.student
    let onLOP = isOnLOP(s);
    return (
      <div className="push-footer">
        <Row className="master-detail-top-separator">
          <Col md={4}>
            <Form onSubmit={this.onSubmit}>
              <FormGroup row>
                <Label for="stuID" md={4}>Student ID</Label>
                <Col md={4}>
                  <Input type="text"
                         autoFocus
                         name="stuID"
                         id="stuID"
                         value={this.state.stuID}
                         onChange={this.onChange}
                         placeholder="Stu ID" />
                </Col>
                <Col md={2}>
                  <Button color="primary" onClick={this.onSubmit}>Check</Button>
                </Col>
              </FormGroup>
            </Form>
          </Col>
          <Col md={8}>
            <Card>
              <CardHeader>
                {
                  (s) ? <div>
                    {
                      (onLOP) ?
                        <h4 className="banner-on-lop">Student is on LOP</h4> :
                        <h4 className="banner-off-lop">Student is not on LOP</h4>
                    }
                  </div> : null
                }
                <StudentHeader student={this.state.student}
                               schedules={this.state.schedule}
                               user={this.props.user}
                               db={this.props.db} />
              </CardHeader>
              <CardBody>
                {
                  (this.state.student) ?
                    <ShowRecords student={this.state.student}
                                 records={this.state.records}
                                 schedule={this.state.schedule}
                                 reasons={this.props.reasons}
                                 user={this.props.user}
                                 db={this.props.db} /> : null
                }
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    )
  }
}

export default Check



// WEBPACK FOOTER //
// ./src/views/Check.js